"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vkBridge = _interopRequireDefault(require("@vkontakte/vk-bridge"));

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var VkObserver = /*#__PURE__*/function () {
  function VkObserver() {
    (0, _classCallCheck2["default"])(this, VkObserver);
  }

  (0, _createClass2["default"])(VkObserver, null, [{
    key: "subscribe",
    value: function subscribe(eventType, callback) {
      if (!VkObserver.subjects.length) {
        _vkBridge["default"].subscribe(VkObserver.observerCallback);
      }

      VkObserver.subjects.push({
        eventType: eventType,
        callback: callback
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(eventType, callback) {
      VkObserver.subjects = VkObserver.subjects.filter(function (subject) {
        return subject.eventType !== eventType && callback !== subject.callback;
      });

      if (!VkObserver.subjects.length) {
        _vkBridge["default"].unsubscribe(VkObserver.observerCallback);
      }
    }
  }]);
  return VkObserver;
}();

exports["default"] = VkObserver;
(0, _defineProperty2["default"])(VkObserver, "subjects", []);
(0, _defineProperty2["default"])(VkObserver, "observerCallback", function (e) {
  var vkEvent = e.detail;

  if (!vkEvent) {
    return;
  }

  var eventType = vkEvent.type;
  var data = vkEvent.data;
  VkObserver.subjects.forEach(function (subject) {
    if (subject.eventType === eventType) {
      subject.callback(data);
    }
  });
});